/*
 * Angebot „Mengenstaffel": Rechenkern (und ab Task 12 die Mengen-Karten).
 *
 * Teil 1, reine Funktionen ohne DOM. Laeuft in Node (module.exports,
 * tests/angebot.test.cjs) und im Browser als window.MoonouAngebot. Leser:
 * assets/moonou-promo-gift.js (Regel staffel), assets/cart.js (Code-Meldung),
 * assets/moonou-bundle-configurator.js (Bundle-Preis).
 * Liquid-Gegenstueck von Zaehlung und Drawer-Zustand:
 * snippets/moonou-angebot-state.liquid. Wer eine Regel hier aendert, aendert sie
 * dort genauso; tests/angebot-vertrag.test.cjs prueft die Reihenfolge.
 *
 * Rundung (Spec 3.6): Rabatt je Stueck auf den Cent abgerundet, dann mal Menge.
 * Nur ganze Cent, keine Fliesskomma-Division.
 *
 * Der Browser-Name MoonouAngebot darf nie als DOM-id vorkommen (Browser legen
 * fuer jede id eine gleichnamige window-Eigenschaft an); der Test prueft das.
 */
(function (root) {
  'use strict';

  const MAX_PROZENT = 90;

  function ganz(value) {
    const n = Number(value);
    return Number.isInteger(n) ? n : NaN;
  }

  /* Stufen aus dem Metaobjekt saeubern. Ein Tippfehler im Metaobjekt darf nie
     „0 %" oder „NaN %" anzeigen: was nicht passt, faellt weg. */
  function normalizeTiers(raw) {
    if (!Array.isArray(raw)) return [];
    const seen = new Set();
    const out = [];
    for (const entry of raw) {
      if (!entry || typeof entry !== 'object') continue;
      const min = ganz(entry.min);
      const prozent = ganz(entry.prozent);
      if (!(min >= 1) || !(prozent >= 1) || prozent > MAX_PROZENT) continue;
      if (seen.has(min)) continue;
      seen.add(min);
      out.push({ min, prozent });
    }
    return out.sort((a, b) => a.min - b.min);
  }

  function tierFor(count, tiers) {
    let hit = null;
    for (const tier of tiers) if (count >= tier.min) hit = tier;
    return hit;
  }

  function nextTier(count, tiers) {
    for (const tier of tiers) if (tier.min > count) return tier;
    return null;
  }

  function discountedUnitCents(priceCents, prozent) {
    const price = Math.trunc(Number(priceCents));
    if (!Number.isFinite(price) || price <= 0) return 0;
    const pct = Math.trunc(Number(prozent));
    if (!Number.isFinite(pct) || pct <= 0) return price;
    const produkt = price * pct;
    return price - (produkt - (produkt % 100)) / 100;
  }

  function lineCents(priceCents, quantity, prozent) {
    const menge = Math.max(0, Math.trunc(Number(quantity)) || 0);
    return discountedUnitCents(priceCents, prozent) * menge;
  }

  /* Gekauft: bezahlt, keine Zugabe (egal welcher Aktion), kein Bundle-Gratisartikel.
     Wortgleich zu isPurchased in assets/moonou-promo-gift.js. */
  const isPurchased = (item) => !!item && item.paid === true && !item.gift && item.bundleRole !== 'gratis';

  function countStaffel(items) {
    if (!Array.isArray(items)) return 0;
    let n = 0;
    for (const item of items) {
      if (!item || item.staffel !== true || !isPurchased(item)) continue;
      const menge = Math.trunc(Number(item.quantity));
      if (menge > 0) n += menge;
    }
    return n;
  }

  function giftEligible(count, giftAb) {
    const ab = ganz(giftAb);
    return ab >= 1 && count >= ab;
  }

  /* Rabattlage eines Warenkorbs (Antwort von /cart.js), Spiegel der Liquid-Regel in
     snippets/moonou-angebot-state.liquid: Zeilenrabatte = original_total_price minus
     items_subtotal_price, getrennt in Staffel (Allokation ohne Code) und
     produktbezogenen Code (type discount_code). Schlaegt ein Produkt-Code die
     Staffel, ist staffelAngewendet false und die ganze Summe gehoert dem Code. */
  function rabattLage(cart) {
    const c = cart || {};
    const items = Array.isArray(c.items) ? c.items : [];
    let staffelTitel = '';
    const codeTitel = [];
    let codeSumme = 0;
    for (const item of items) {
      const allocs = item && Array.isArray(item.line_level_discount_allocations) ? item.line_level_discount_allocations : [];
      for (const a of allocs) {
        if (!a || !(a.amount > 0) || !a.discount_application) continue;
        const titel = String(a.discount_application.title || '');
        if (a.discount_application.type === 'discount_code') {
          codeSumme += Math.trunc(a.amount);
          if (!codeTitel.includes(titel)) codeTitel.push(titel);
        } else if (!staffelTitel) {
          staffelTitel = titel;
        }
      }
    }
    const zeilen = Math.max(0, Math.trunc(Number(c.original_total_price) || 0) - Math.trunc(Number(c.items_subtotal_price) || 0));
    const staffelAngewendet = staffelTitel !== '';
    let mengenrabattCent;
    if (staffelAngewendet) mengenrabattCent = Math.max(0, zeilen - codeSumme);
    else if (codeTitel.length) mengenrabattCent = 0;
    else mengenrabattCent = zeilen;
    const bestellcodes = Array.isArray(c.cart_level_discount_applications) ? c.cart_level_discount_applications.length : 0;
    return {
      staffelAngewendet,
      codeAktiv: bestellcodes > 0 || codeTitel.length > 0,
      mengenrabattCent,
      mengenrabattTitel: staffelTitel,
      codeZeilenCent: zeilen - mengenrabattCent,
      codeZeilenTitel: codeTitel.join(', ')
    };
  }

  /* R17 Gesamtrabatt: Summenblock bei aktivem Angebot, Spiegel von Feld 20 in
     snippets/moonou-angebot-state.liquid und snippets/moonou-angebot-gesamtrabatt.liquid.
     Warenwert = original_total_price + Wert der Geschenkzeilen, Du sparst = Staffel
     + Geschenkwert, Codes bleiben eigene Zeilen. Es gilt immer
     warenwert - duSparst - codeZeilen - Bestellcodes = items_subtotal_price - Bestellcodes
     = total_price. /cart.js liefert keinen Streichpreis: wertJeStueck(item) gibt ihn
     fuer Geschenkzeilen (Standard item.compare_at_price). Geschenk = _gift gesetzt
     (das Tag geschenk kennt nur Liquid). Nur ganze Cent. */
  function summen(cart, wertJeStueck) {
    const c = cart || {};
    const items = Array.isArray(c.items) ? c.items : [];
    const wert = typeof wertJeStueck === 'function' ? wertJeStueck : (item) => item.compare_at_price;
    let geschenkCent = 0;
    for (const item of items) {
      if (!item) continue;
      const props = item.properties || {};
      if (props._gift == null || String(props._gift).trim() === '') continue;
      const stueck = (Math.trunc(Number(wert(item))) || 0) - (Math.trunc(Number(item.original_price)) || 0);
      const menge = Math.max(0, Math.trunc(Number(item.quantity)) || 0);
      if (stueck > 0) geschenkCent += stueck * menge;
    }
    const lage = rabattLage(c);
    const bestellcodes = (Array.isArray(c.cart_level_discount_applications) ? c.cart_level_discount_applications : [])
      .filter(Boolean)
      .map((d) => ({ titel: String(d.title || ''), cent: Math.trunc(Number(d.total_allocated_amount)) || 0 }));
    const warenwertCent = (Math.trunc(Number(c.original_total_price)) || 0) + geschenkCent;
    return {
      warenwertCent,
      duSparstCent: lage.mengenrabattCent + geschenkCent,
      staffelCent: lage.mengenrabattCent,
      geschenkCent,
      codeZeilenCent: lage.codeZeilenCent,
      codeZeilenTitel: lage.codeZeilenTitel,
      bestellcodes
    };
  }

  /* Ueberschrift der Stufenleiste. Reihenfolge der Faelle = Reihenfolge in
     snippets/moonou-angebot-state.liquid (assign zustand = ...). opts = rabattLage(cart). */
  function drawerState(count, tiers, opts) {
    const o = opts || {};
    if (!Array.isArray(tiers) || !tiers.length) {
      return { key: 'aus', prozent: 0, naechsteMin: 0, naechsteProzent: 0, fehlend: 0 };
    }
    const current = tierFor(count, tiers);
    const next = nextTier(count, tiers);
    let key;
    if (!current) key = 'unter';
    else if (o.staffelAngewendet === false && o.codeAktiv === true) key = 'code';
    else if (!next) key = 'oben';
    else if (current === tiers[0]) key = 'erste';
    else key = 'mitte';
    return {
      key,
      prozent: current ? current.prozent : 0,
      naechsteMin: next ? next.min : 0,
      naechsteProzent: next ? next.prozent : 0,
      fehlend: next ? next.min - count : 0
    };
  }

  /* Meldung fuer das Code-Feld. cart = Antwort von /cart/update.js. Shopify meldet
     einen schwaecheren Code als applicable:false und haelt ihn aus
     cart_level_discount_applications heraus; greift zugleich ein automatischer
     Zeilenrabatt (die Staffel), ist das die ehrliche Erklaerung. */
  function codeMessage(cart, code) {
    if (!cart || !Array.isArray(cart.discount_codes) || typeof code !== 'string') return null;
    const gesucht = code.trim().toUpperCase();
    const eintrag = cart.discount_codes.find((d) => d && typeof d.code === 'string' && d.code.toUpperCase() === gesucht);
    if (!eintrag || eintrag.applicable !== false) return null;
    const items = Array.isArray(cart.items) ? cart.items : [];
    const staffel = items.some((item) => (item && Array.isArray(item.line_level_discount_allocations) ? item.line_level_discount_allocations : [])
      .some((a) => a && a.amount > 0 && a.discount_application && a.discount_application.type !== 'discount_code'));
    return staffel ? 'staffel_besser' : 'ungueltig';
  }

  function handleize(text) {
    return String(text).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  /* Geschenk-Variante im Design eines Produkts: der Variantentitel („Twuro")
     steckt als Teil im Handle (moonou-twuro, twuro-farbig). */
  function giftVariantFor(variants, productHandle) {
    if (!Array.isArray(variants) || typeof productHandle !== 'string') return null;
    const teile = productHandle.toLowerCase().split('-');
    for (const v of variants) {
      if (!v || typeof v.title !== 'string') continue;
      const design = handleize(v.title);
      if (design && teile.includes(design)) return v;
    }
    return null;
  }

  /* Bundle-Konfigurator: Summe der BEZAHLTEN Slots. Staffel-Slots nach 3.6,
     alle anderen (Sockel+Schirm) voll. Gratis-Slot und Geschenke gehoeren nicht hinein. */
  function bundleTotals(paidSlots, tiers) {
    const list = Array.isArray(paidSlots) ? paidSlots.filter(Boolean) : [];
    const count = list.filter((s) => s.staffel === true).length;
    const tier = tierFor(count, tiers);
    const prozent = tier ? tier.prozent : 0;
    let total = 0;
    for (const s of list) {
      total += s.staffel === true ? discountedUnitCents(s.price, prozent) : Math.max(0, Math.trunc(Number(s.price)) || 0);
    }
    return { total, prozent, count };
  }

  /* Optionswert der Einzelvariante („1 Stueck"): erster Wert mit fuehrender 1. */
  function einzelOptionswert(values) {
    if (!Array.isArray(values) || !values.length) return null;
    for (const v of values) if (parseInt(String(v), 10) === 1) return v;
    return values[0];
  }

  /* 2-Stueck-Karte (R12): fester Preis nach Spec 3.6 aus dem Einzelpreis,
     Streichpreis = 2 x Einzelpreis. Unabhaengig vom Warenkorb. */
  function zweiStueckPreise(einzelCents, prozent) {
    const einzel = Math.max(0, Math.trunc(Number(einzelCents)) || 0);
    return { zwei: discountedUnitCents(einzel, prozent) * 2, zweiStreich: einzel * 2 };
  }

  const api = { normalizeTiers, tierFor, nextTier, discountedUnitCents, lineCents, isPurchased, countStaffel,
    giftEligible, rabattLage, summen, drawerState, codeMessage, giftVariantFor, bundleTotals, einzelOptionswert,
    zweiStueckPreise };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
    return;
  }
  root.MoonouAngebot = api;

  /*
   * Teil 3, nur Browser (R14, 05.10.2026): Bild und Titel der Vasen-Zeile in
   * Drawer und Warenkorbseite ([data-angebot-geschenk-popup]) sowie der Link
   * im PDP-Ticket (.moonou-promo-gift-link) oeffnen das Geschenk-Popup
   * x-modal#MoonouPromoGift (snippets/moonou-promo-popup.liquid, angebot: true).
   * Delegation am document: der Drawer rendert seine Zeilen bei jeder
   * Aenderung neu, ModalElement bindet aber nur die Bedienelemente, die beim
   * Start im DOM stehen. Ohne Popup (oder ohne JS) fuehrt der href weiter zur
   * Produktseite. Oeffnen, ESC und Fokusfalle macht ModalElement selbst; ueber
   * dem offenen Drawer schliesst ESC nur das Popup, danach bekommt der Drawer
   * seine Fokusfalle zurueck.
   */
  if (root.document && typeof root.document.addEventListener === 'function'
    && typeof root.addEventListener === 'function' && !root.__moonouAngebotGeschenkPopup) {
    root.__moonouAngebotGeschenkPopup = true;
    const POPUP_ID = 'MoonouPromoGift';
    const popupHolen = () => {
      const popup = root.document.getElementById(POPUP_ID);
      return popup && typeof popup.show === 'function' ? popup : null;
    };
    const offenerDrawer = () => {
      const drawer = root.document.querySelector('cart-drawer');
      return drawer && drawer.open ? drawer : null;
    };
    root.document.addEventListener('click', (event) => {
      const ausloeser = event.target && event.target.closest
        ? event.target.closest('[data-angebot-geschenk-popup], .moonou-promo-gift-link')
        : null;
      if (!ausloeser) return;
      const popup = popupHolen();
      if (!popup) return;
      event.preventDefault();
      /* Ticket-Links bindet ModalElement beim Start selbst und hat dann schon geoeffnet. */
      if (!popup.open) popup.show(ausloeser);
    });
    root.addEventListener('keyup', (event) => {
      if (event.code !== 'Escape') return;
      const popup = popupHolen();
      if (!popup || !popup.open || !offenerDrawer()) return;
      event.stopImmediatePropagation();
      popup.hide();
    }, true);
    root.document.addEventListener('modal:afterHide', (event) => {
      if (!event.target || event.target.id !== POPUP_ID) return;
      const drawer = offenerDrawer();
      if (!drawer || !root.theme || !root.theme.a11y) return;
      const zurueck = event.target.activeElement;
      /* Nach dem removeTrapFocus aus ModalElement.afterHide (setTimeout) neu setzen. */
      root.setTimeout(() => {
        const ziel = zurueck && zurueck.isConnected && drawer.contains(zurueck) ? zurueck : drawer;
        root.theme.a11y.trapFocus(drawer, ziel);
      }, 30);
    });
  }

  /*
   * Teil 2, nur Browser: 1-/2-Stueck-Karten (snippets/moonou-variant-cards.liquid).
   * ProductInfo (assets/theme.js) ersetzt den variant-picker bei jedem
   * Variantenwechsel. Die gewaehlte Menge lebt deshalb in einer Map je
   * Formular-ID und wird nach jedem Neuaufbau und nach variant:change wieder
   * angewendet (Review Focus 1 im Phase-3-Plan).
   */
  if (!root.customElements || root.customElements.get('moonou-angebot-menge')) return;
  const gemerkt = root.__moonouAngebotMengen || (root.__moonouAngebotMengen = {});

  class AngebotMenge extends HTMLElement {
    connectedCallback() {
      this.formId = this.getAttribute('data-form') || '';
      this.onKlick = this.onKlick.bind(this);
      this.onTaste = this.onTaste.bind(this);
      this.onVariante = (event) => {
        /* Der alte, schon ausgeblendete variant-picker bleibt bis zu 500 ms im
           DOM (theme.HTMLUpdateUtility.viewTransition): nicht mit alten Preisen
           ueberschreiben. */
        const picker = typeof this.closest === 'function' ? this.closest('variant-picker') : null;
        if (picker && picker.style && picker.style.display === 'none') return;
        this.preiseAusVariante(event && event.detail ? event.detail.variant : null);
        this.anwenden();
      };
      this.addEventListener('click', this.onKlick);
      this.addEventListener('keydown', this.onTaste);
      /* Das Formular (Block buy_button) steht im Markup NACH den Karten. */
      const start = () => {
        this.formular = document.getElementById(this.formId);
        if (this.formular) this.formular.addEventListener('variant:change', this.onVariante);
        this.alteDoppelpackung();
        this.anwenden();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
      else start();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onKlick);
      this.removeEventListener('keydown', this.onTaste);
      if (this.formular) this.formular.removeEventListener('variant:change', this.onVariante);
    }

    /* Alter Link auf eine 2-Stueck-Variante (Review Focus 5): auf die
       Einzelvariante wechseln und Menge 2 vorwaehlen, einmal je Formular. */
    alteDoppelpackung() {
      if (Object.prototype.hasOwnProperty.call(gemerkt, this.formId)) return;
      const einzel = this.getAttribute('data-einzel-wert');
      const gewaehlt = this.querySelector('fieldset input:checked');
      if (!einzel || !gewaehlt || gewaehlt.value === einzel) return;
      gemerkt[this.formId] = parseInt(gewaehlt.value, 10) === 2 ? 2 : 1;
      const ziel = Array.from(this.querySelectorAll('fieldset input')).find((i) => i.value === einzel);
      if (ziel) {
        ziel.checked = true;
        ziel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    /* Leuchten- oder Farbwechsel (R12): Kartenpreise aus der neuen
       Einzelvariante, auch bevor bzw. falls der Neuaufbau ausbleibt. */
    preiseAusVariante(variant) {
      if (!variant || !Number.isInteger(variant.price)) return;
      const einzelWert = this.getAttribute('data-einzel-wert');
      if (einzelWert && Array.isArray(variant.options) && !variant.options.includes(einzelWert)) return;
      const prozent = parseInt(this.getAttribute('data-prozent'), 10) || 0;
      const p = zweiStueckPreise(variant.price, prozent);
      const theme = root.theme;
      const format = theme && theme.Currency && typeof theme.Currency.formatMoney === 'function' && theme.settings
        ? (c) => theme.Currency.formatMoney(c, theme.settings.currencyCodeEnabled ? theme.settings.moneyWithCurrencyFormat : theme.settings.moneyFormat)
        : null;
      this.querySelectorAll('[data-angebot-menge]').forEach((k) => {
        const zwei = Number(k.getAttribute('data-angebot-menge')) === 2;
        const preis = zwei ? p.zwei : variant.price;
        k.setAttribute('data-preis', String(preis));
        if (!format || typeof k.querySelector !== 'function') return;
        const preisEl = k.querySelector('.moonou-variant-cards__card-price');
        if (preisEl) preisEl.innerHTML = format(preis);
        const streichEl = k.querySelector('.moonou-variant-cards__card-compare');
        const streich = zwei ? p.zweiStreich : (Number(variant.compare_at_price) || 0);
        if (streichEl) {
          streichEl.innerHTML = format(streich);
          streichEl.hidden = !(streich > preis);
        }
      });
    }

    anwenden() {
      const menge = gemerkt[this.formId] === 2 ? 2 : 1;
      const feld = this.querySelector('[data-angebot-menge-input]');
      if (feld) feld.value = String(menge);
      let karte = null;
      this.querySelectorAll('[data-angebot-menge]').forEach((k) => {
        const an = Number(k.getAttribute('data-angebot-menge')) === menge;
        k.setAttribute('aria-checked', an ? 'true' : 'false');
        k.tabIndex = an ? 0 : -1;
        if (an) karte = k;
      });
      const label = this.querySelector('[data-angebot-menge-label]');
      if (label && karte) label.textContent = karte.getAttribute('data-label') || '';
      const preis = document.querySelector('product-buy-price[form="' + this.formId + '"]');
      if (preis && karte && typeof preis.updatePrice === 'function') {
        preis.updatePrice(Number(karte.getAttribute('data-preis')) || 0);
      }
      this.dispatchEvent(new CustomEvent('moonou:angebot-menge', { bubbles: true, detail: { menge } }));
    }

    waehlen(menge) {
      gemerkt[this.formId] = menge === 2 ? 2 : 1;
      this.anwenden();
    }

    onKlick(event) {
      const k = event.target.closest('[data-angebot-menge]');
      if (!k) return;
      event.preventDefault();
      this.waehlen(Number(k.getAttribute('data-angebot-menge')));
    }

    onTaste(event) {
      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
      if (!event.target.closest('[data-angebot-menge]')) return;
      event.preventDefault();
      const neu = gemerkt[this.formId] === 2 ? 1 : 2;
      this.waehlen(neu);
      const k = this.querySelector('[data-angebot-menge="' + neu + '"]');
      if (k) k.focus();
    }
  }
  root.customElements.define('moonou-angebot-menge', AngebotMenge);
})(typeof window !== 'undefined' ? window : globalThis);
